/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, ValidateNested } from 'class-validator';

import {
  Filter,
  BaseFilter,
  TextFilter,
  SelectFilter,
  MultipleFilter,
  BoolFilter,
  SearchFilter,
  MultipleSearchFilter,
  TimeRangeFilter,
} from './filter.entity';

export class FiltersResponse {
  @IsNotEmpty()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => BaseFilter, {
    discriminator: {
      property: 'type',
      subTypes: [
        { value: TextFilter, name: 'text' },
        { value: SelectFilter, name: 'select' },
        { value: MultipleFilter, name: 'multiple' },
        { value: BoolFilter, name: 'bool' },
        { value: SearchFilter, name: 'search' },
        { value: MultipleSearchFilter, name: 'multiple-search' },
        { value: TimeRangeFilter, name: 'timerange' },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  filters: Filter[];
}
